import { Box, Stack, Tooltip } from "@mui/material";
import Step from "@mui/material/Step";
import StepButton from "@mui/material/StepButton";
import Stepper from "@mui/material/Stepper";
import React, { useEffect, useMemo, useRef, useState } from "react";

import TaskField from "./taskField";

function EllipsisStepButton({ label, onClick }) {
  const textRef = useRef(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    const checkOverflow = () => {
      if (textRef.current) {
        setIsOverflowing(textRef.current.scrollWidth > textRef.current.clientWidth);
      }
    };
    checkOverflow();
    window.addEventListener("resize", checkOverflow);
    return () => window.removeEventListener("resize", checkOverflow);
  }, [label]);

  const button = (
    <StepButton
      onClick={onClick}
      disabled={false}
      sx={{
        cursor: "pointer",
        "& .MuiStepLabel-label": {
          maxWidth: 70,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        },
      }}
    >
      <span ref={textRef} style={{ display: "inline-block", maxWidth: 70, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
        {label}
      </span>
    </StepButton>
  );

  if (isOverflowing) {
    return (
      <Tooltip
        title={label}
        arrow
        placement="top"
        slotProps={{
          popper: {
            modifiers: [
              {
                name: "offset",
                options: {
                  offset: [0, -25],
                },
              },
            ],
          },
        }}
      >
        {button}
      </Tooltip>
    );
  }

  return button;
}

export default function TaskStepper(props) {
  const stepsProp =
    props.fieldProperties?.properties?.find?.((p) => p.id === "steps") ||
    props.attributes?.properties?.find?.((p) => p.id === "steps");
  const steps = Array.isArray(stepsProp?.value) ? stepsProp.value : [];

  const [activeStep, setActiveStep] = useState(0);
  useEffect(() => {
    const maxIndex = Math.max(0, steps.length - 1);
    if (activeStep > maxIndex) {
      setActiveStep(maxIndex);
      if (props.onStepChange) props.onStepChange(maxIndex);
    }
  }, [steps.length]);

  const handleHeaderClick = (index) => {
    if (index < 0 || index >= steps.length) return;
    setActiveStep(index);
    if (props.onStepChange) props.onStepChange(index);
  };

  const stepItems = useMemo(() => {
    const passo = props.fieldProperties?.items?.[activeStep];
    return passo?.items || [];
  }, [props.fieldProperties, activeStep]);

  return (
    <Box sx={{ justifyContent: "center", width: "100%" }}>
      <Stepper nonLinear activeStep={activeStep}>
        {steps.map((step, index) => {
          const stepLabel = step?.name || `Etapa ${index + 1}`;
          return (
            <Step key={step.id || step.name || index} sx={{ maxWidth: 100 }}>
              <EllipsisStepButton
                label={stepLabel}
                onClick={() => handleHeaderClick(index)}
              />
            </Step>
          );
        })}
      </Stepper>

      <Stack spacing={2} sx={{ mt: 3 }}>
        {stepItems.map((slot, i) => {
          const current = slot?.items?.[0];
          if (!current) return null;
          return (
            <TaskField
              {...props}
              isPreview={props.isPreview}
              bpmForm={props.bpmForm}
              attributes={current}
              name={current.id}
              component={current.id}
              domNode={current}
              key={current.uuid || `${current.id || "item"}-${i}`}
              onChange={props.eventHandle}
              value={!props.isPreview && props.getValueHandle?.(current.id)}
              fieldProperties={current}
              error={!props.isPreview && props.getErrorHandle?.(current.id)}
              readOnly={!!props.readOnly}
              className={
                props.carga && props.carga.value ? "containerCarga" : ""
              }
              carga={props.carga && props.carga.value}
            />
          );
        })}
      </Stack>
    </Box>
  );
}
